// extracted by mini-css-extract-plugin
export default {"cls1":"kL0Q8_l9MKXAUBcftvV6","cls2":"S4kpOYuCjpCjOAII77qx kL0Q8_l9MKXAUBcftvV6","isPhone":"Y_u_AzZVwaKFnNfeiW2z","isTabletDown":"cT_2GdyXeIbpm2UDBzGi"};